import React from 'react';
import { DatePicker, Button } from 'antd';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

export default function Filter(props) {
    const { curRole } = sessionStorage;
    const { searchParams, maxDate, onSearch, onExport, onChange } = props;
    
    const disabledDate = (current) => {
        const minValue = moment('2021-12').valueOf();
        const value = moment(maxDate).valueOf();
        const month = current.month();
        return (
            current &&
            !(
                current.valueOf() >= minValue &&
                current.valueOf() <= value &&
                (month === 5 || month === 11)
            )
        );
    }
    
    const handleChange = (value, key) => {
        switch (key) {
            default: {
                searchParams[key] = value;
                break;
            }
        }
        onChange(searchParams);
    }
        
    const date = searchParams.date ? moment(searchParams.date) : null;
    return (
        <div className="search-bar" style={{ margin: '10px 0' }}>
           <div className="search-item">
                <label className="ui-label">时间</label>
                <MonthPicker
                    format={monthFormat}
                    allowClear={false}
                    value={date}
                    style={{width: 90}}
                    disabledDate={disabledDate}
                    onChange={(date, dateString) => handleChange(dateString, 'date')}
                />
            </div>
            <div className="search-item">
                <Button type="primary" onClick={onSearch}>搜索</Button>
                { curRole !== 'CRC' && <Button type="primary" onClick={onExport}>导出</Button> }
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/components/Filter.js